import { environmentTest } from '@common/environments/environments';

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    apiUri: 'https://api-enus-demo.ichoosr.com/',
    identityUri: 'https://identity-us-demo.ichoosr.com',
    backofficeIdentityUri: 'https://identity-demo.ichoosr.com',
    googleApiKey: environmentTest.googleApiKey,
    allowLinksToCms: true,
    analyticsUri: 'https://analytics-demo.ichoosr.com',
    addressServiceUri: 'https://ichoosr-addresses-us-test.azurewebsites.net',
    communityForumUri: 'https://ichoosrtest.freshdesk.com/en/support/discussions',
    analyticsSendToTagManager: false,
    isProdEnvironment: false,
    cmsUri: 'https://content-us.ichoosr.com/api/',
    aiConnectionString: ''
};

